import React, {useState,useEffect,useContext,useRef}from 'react'
import moment from 'moment';
import arrow from '../images/thinArrow.png'
import checkmarkGreen from '../images/checkmark-green.png';
import checkmarkRed from '../images/checkmark-red.png'
import calendar from '../images/Icon-Calendar.png';
import { DayPicker  } from 'react-day-picker';
import da from "date-fns/locale/da";
import close from '../images/close.png'
import { keyContext } from "../components/KeyContext";
import { format, isSameMonth, nextSaturday } from "date-fns";
import NewsletterEditing from './NewsletterEditing';


function NewsletterDiv({newsletter_data,orgID,setNewsletterModal,}) {
   
  const key = sessionStorage.getItem("key");
  const disabledDays = [{ from: new Date(2022, 0, 1), to:  moment().subtract(1, 'day').toDate() }] ;
  const {editDiv, setEditDiv, setOpenSideDiv, setContentEdit,openSideDiv, setClickedNewsletter} = useContext(keyContext)
  const [newsletter, setNewsletter] = useState(newsletter_data);
  const [newsletterUpdate, setNewsletterUpdate] = useState([{}]);
  //const [editModal, setEditModal] = useState(false);
    const [clickedNewsNo, setClickedNewsNo] = useState(newsletter.No);
    const [calendarOpen, setcalendarOpen] = useState();
    const [showDiv, setShowDiv] = useState(false);
    const [segmentName, setSegmentName] = useState();
    const [changedNewsletterName, setChangedNewsletterName] = useState(newsletter.Name);
    const [changedDate, setChangedDate] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [month, setMonth] = useState(); 
    const [segments, setSegments] = useState([{}]);
    const [segmentNo, setsegmentNo] = useState();
    const [status, setStatus] = useState(newsletter.ScheduleSendt);
 
    const [chosenTemplate, setChosenTemplate] = useState(newsletter.Body);


  function handleNewsletterDlt (no) {
    
       setClickedNewsletter(no)
       setNewsletterModal(true)
     
  }

        // -------SEGMENTS---------
      useEffect(() => {
               if(key && orgID) { 
           
               const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_segments_get?Key=${key}&OrgNo=${orgID}`;
                fetch(endpoint, {
                   method: "GET",
                   headers: {
                     ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                   },
                 
                 })
                 .then(res => {    
                  return res.json()
                 })
                 .then(result => {
                   setSegments(result)
                   setsegmentNo(result[0].No)
                    // console.log(result)
                 
                 })
                  }
             }, [key,orgID]);
            
    useEffect(() => {
        setSegmentName(newsletter.map)
    }, [segments,newsletter]);
    
  const [changedTimestamp, setChangedTimestamp] = useState(moment(newsletter.ScheduleSendtTime).format('HH:mm'));
  let date = moment(selectedDate).format("DD.MM.YYYY") 

     function handleClick (no) {
         setShowDiv((current => !current))
         setClickedNewsNo(no)
         setEditDiv(false)
         setOpenSideDiv(false)
    }
   function timestampChange (e) {
      //  console.log(e.target.value)
       setChangedTimestamp(e.target.value)
    }
      function handleCalendar() {
     setcalendarOpen(current => !current)
    }

    function handleDatoSelect () {
     setChangedDate(true)
     setcalendarOpen(false)
    }

    function handleNewsletterName (e) {
      setChangedNewsletterName(e.target.value)
    }


function handleSegmentChange (e) {

  const select = document.getElementById("mySelect");

  const selectedOptionId = select.options[select.selectedIndex].id;
  setsegmentNo(selectedOptionId)
}

 // ------------NEWSLETTER UPDATE ----------
    function saveChanges () {
    
      let schduleSendtTime = moment(selectedDate).format('YYYY-MM-DD')+'T'+changedTimestamp
     
         const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_update?Key=${key}&NewsletterNo=${newsletter.No}&strName=${changedNewsletterName}&strSubject=${changedNewsletterName}&SegmentNo=${segmentNo}&ScheduleSendt=${status}&ScheduleSendtTime=${schduleSendtTime}`;
                   fetch(endpoint, {
                      method: "GET",
                      headers: {
                        ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                      },
                    
                    })
                    .then(res => {    
                     return res.json()
                    })
                    .then(result => {
                      setNewsletterUpdate(result)
                      setNewsletter(result)
                      
                    
                    })

                    setShowDiv(false)
        
    }
   
        function findSegmentName () {
            let segment 
                segments.map((seg) => {
                    if(newsletter.NewsgroupNo === seg.No) {
                        
                        segment = seg.Name
                        return segment
                    }
                })
                        return segment          
        }
    const iframeRef = useRef(null);
    const svg = ` <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>`
  return (
         <div style={{position:'relative',}}> 
         
           <div style={{height:'55px',
            border:  '1px solid #ccced1' ,borderTopLeftRadius:'8px',marginTop:'8px',borderTopRightRadius:'8px',borderBottomLeftRadius:showDiv === true && clickedNewsNo === newsletter.No ? '' : '8px',borderBottomRightRadius:showDiv === true && clickedNewsNo === newsletter.No ? '' : '8px'}}>
            <div className='newsMailBody' onClick={() => handleClick(newsletter.No)} style={{cursor:'pointer'}}> 
          <p style={{alignContent:'center',paddingLeft:'16px',margin:0}}>{newsletter.Name}</p>
          <p style={{alignContent:'center',textAlign:'center',margin:0}}>{findSegmentName()}</p>
          <p style={{alignContent:'center',textAlign:'center',margin:0}}> {moment(newsletter.ScheduleSendtTime).format('DD.MM.YYYY')} </p>
          <p style={{alignContent:'center',textAlign:'center',margin:0}}> {newsletter.ScheduleSendtTime.split("T")[1].slice(0,5)} </p>
          <p style={{alignContent:'center',textAlign:'center',margin:0}}>
         {newsletter.ScheduleSendt === 0 ?    '–': ''}
         {newsletter.ScheduleSendt === 1 ? <img src={checkmarkGreen} alt='checkmarkgreen' /> : ''}
            </p>
          <p  style={{textAlign:'center',lignContent:'center',
           // marginTop:showDiv === false && clickedNewsNo === newsletter.No ? 
           //'12px':'', 
           margin:0,
           rotate:showDiv === true && clickedNewsNo === newsletter.No ? '180deg' : '',alignContent:'center'}}>           
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" viewBox="0 0 18 10" fill="none">
               <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
            </svg>
          </p>
         
        </div>
       
       </div>
   

        {
          showDiv === true && clickedNewsNo === newsletter.No ? <div style={{borderLeft: clickedNewsNo === newsletter.No ? '1px solid #ccced1' : '',
            borderRight: clickedNewsNo === newsletter.No ? '1px solid #ccced1' : '',
         borderBottom: clickedNewsNo === newsletter.No ? '1px solid #ccced1' : '',
         marginTop:'-5px',paddingBottom:'20px'
         }}>
            <div className='openedMailDiv' style={{paddingLeft:'80px',paddingTop:'30px',paddingBottom:'30px'}} >
             <div style={{width:'450px',marginRight:'51px'}}>
                 <p className='openedMailTitel'>Navn på nyhedsmail</p>
                 <input style={{width:'100%',padding:'6px 13px 8px',borderRadius:'4px',border:'1px solid #8d8d8d',marginTop:'10px',color:'#101010'}} type="text" value={changedNewsletterName} 
                 onChange={(e) =>  setChangedNewsletterName(e.target.value)}/>
             </div>
             <div style={{width:'178px',marginRight:'28px',position:'relative'}}>
                 <p className='openedMailTitel' style={{fontSize:'16px'}}>Vælg udsendelsesdato</p>
                <div style={{width:'100%',padding:'6px 13px 8px',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'13px',height:'40px',color:'#46484c'}} >
                {changedDate ? moment(selectedDate).format('DD.MM.YYYY') : moment(newsletter.ScheduleSendtTime).format('DD.MM.YYYY')} 
                   <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',top:'38px',height:'38px'}}></span>
                   <button onClick={handleCalendar} style={{position:'absolute',right:'5px',top:'42px'}}><img  src={calendar} alt="" /></button>   
                </div>

                 {calendarOpen ? (
    <div className='startDatoCal' style={{top:'80px'}}>
        <div style={{height:'35px',backgroundColor:'#f1f5f9',display:'flex',justifyContent:'space-between',margin:'4px',}}>
           <p style={{fontSize:'12px',fontWeight:'bold',padding:'8px'}}>Startdato</p>
         
        </div>
        <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
        <DayPicker 
         month={month} 
            onMonthChange={setMonth}  locale={da} mode="single" ISOWeek  showOutsideDays  showWeekNumber selected= {selectedDate} captionLayout="dropdown" fromYear={2022} toYear={2030} 
             onSelect={setSelectedDate} 
             onDayClick={handleDatoSelect}  disabled={disabledDays}/>
    </div>
                ) : ''}
                
             </div>
              <div style={{width:'178px',position:'relative'}}>
                 <p className='openedMailTitel' style={{fontSize:'16px'}}>Vælg tidspunkt</p>
               <div style={{width:'100%',padding:'6px 13px 8px',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'13px',height:'40px',color:'#46484c',position:'relative'}}> 
                 <span style={{position:'absolute',zIndex:9}}>Kl.</span>
                
                 <input onChange={(e) => timestampChange(e)} style={{border:'none',width:'97%',color:'#46484c',position:'absolute',right:'4px',top:'3px'}} 
                  className='time-input ' 
                   type="time" id="appointment" 
                    value= {changedTimestamp }  />
                
                   <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'28px',top:'0px',height:'39px'}}></span>
                   {/* <span style={{position:'absolute',right:'10px'}}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10"   viewBox="0 0 18 10" fill="none">
                        <path d="M0.353546 0.355469L8.85355 8.85547L17.3535 0.355469" stroke="#101010"/>
                       </svg>
                   </span> */}
                  
            
             </div>
             </div>
             </div>
             <div className='openedMailDiv' style={{paddingLeft:' 80px'}}>
               <div style={{width:'450px',marginRight:'51px',position:'relative'}}>
                 <p className='openedMailTitel'>Vælg segment</p>
               
                   <select 
                  //  onChange={(e) => handleSegmentChange(e)}
                    id='mySelect' style={{  backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(svg)}")`,width:'100%',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'10px',height:'40px'}}  className="form-select text-truncate" >
                     {segments &&
                       segments.map((item) => {
                     
                      return (
                       <option  key={item.id} value={item.No} id={item.No}
                         className="text-truncate"  style={{  maxWidth:'280px',  marginLeft: '10px',   fontSize: "16px",  width:'250px' }}>
                           {item.Name} 
                        </option>
                         );
                        })}
                    </select>
                    <span className="select-line" style={{ backgroundColor: "#8d8d8d" ,position:'absolute',right:'30px',top:'37px',height:'40px',width:'0.5px'}}></span>
             
             </div>
             <div>
                <p className='openedMailTitel'>Status for udsendelse</p>
               <div style={{display:'flex', width:'387px'}}>
                 <div style={{borderTop:'1px solid #8d8d8d',padding:'6.5px 12px',width:'180px',borderLeft:'1px solid #8d8d8d',borderBottom:'1px solid #8d8d8d',borderTopLeftRadius:'4px',borderBottomLeftRadius:'4px',marginTop:'10px',height:'40px',position:'relative'}}>
                   <input  type="radio"    id="zeroid"
                    //checked={newsletter.ScheduleSendt === 1 ? true : false} 
                    value={1} checked={status === 1} onChange={() => setStatus(1)} 
                    name='newsletter' height='16px' width='16px'/>
                  <label htmlFor="" style={{position:'absolute',bottom:'7px'}}>Aktiveret</label>
                  
                  </div>
                  <div style={{border:'1px solid #8d8d8d',padding:'6.5px 11px',width:'209px',borderTopRightRadius:'4px',borderBottomRightRadius:'4px',marginTop:'10px',height:'40px',position:'relative'}}>
                   <input  type="radio"  value={0}
        checked={status === 0}
        onChange={() => setStatus(0)} id="oneid"
                     name='newsletter' />
                    <label htmlFor="" style={{position:'absolute',bottom:'7px'}}>Ikke aktiveret</label>
                  
                  </div>
                </div>
                
             </div>
             </div>
              <div className='openedMailDiv' style={{paddingTop:'30px',paddingLeft:'80px'}}>
                 <div style={{width:'450px',marginRight:'51px'}}>
                   <p className='openedMailTitel'>Emnefelt på nyhedsmail</p>
                   <input style={{width:'100%',padding:'6px 13px 8px',border:'1px solid #8d8d8d',borderRadius:'4px',marginTop:'10px',color:'#101010'}} type="text" value={newsletter.Name} onChange={handleNewsletterName}/>
                 </div>
                { newsletter.ScheduleSendt === 1 ? 
                  <div style={{marginTop:'38px'}}>
                    <img src={checkmarkGreen} alt="" style={{marginRight:'10px'}}/>
                    <span className='openedMailTitel'>Udsendelse  aktiveret</span>
                  </div> 
                 :
                  <div style={{marginTop:'28px'}}>
                    <img src={checkmarkRed } alt="" style={{marginRight:'10px'}}/>
                    <span className='openedMailTitel'>Udsendelse ikke aktiveret</span>
                  </div>
                }
             
              </div>
             <button onClick={saveChanges} style={{width:'890px',backgroundColor:'#982f2f',height:'40px',margin:'33px 80px',color:'white',borderRadius:'4px',fontSize:'14px'}}>GEM</button>
             
           <hr style={{width:'1037px',height:'1px',backgroundColor:'#ccced1'}}/>
           <section style={{}}>
              <div style={{display:'flex',textAlign:'center',width:openSideDiv === false ? '565px' : '',margin:'auto',paddingBottom:'18px'}}>
                <p className='openedMailTitel' style={{paddingTop:'8px'}}>Jeres mail</p>
               
              </div>
             
              <div style={{border:'1px solid #8d8d8d',borderRadius:'4px',padding:editDiv === false ?'10px':'',marginTop:'18px',width:openSideDiv === false ?'540px':'',margin:'auto',//boxShadow:editDiv === true ? '7px 6px 30px 17px #000000' : '',
                display:editDiv === true ? 'flex':'',position:'relative'}}> 

      
                   <NewsletterEditing chosenTemplate={chosenTemplate} orgID={orgID} setChosenTemplate={setChosenTemplate} newsletterNo={newsletter.No}  sideDiv={true} /> 
                   
                   {openSideDiv === true ? 
                     <button style={{height:'20px',position:'absolute',right:0,top:0}}><img src={close} alt="" onClick={() => { setEditDiv(false); setOpenSideDiv(false);setContentEdit(false) }}/></button> 
                      : null} 
              </div>
              <br />
          </section>
          </div> : null
          
        }
        <button style={{position:'absolute',top:'2px',right:'-35px'}} onClick={ () =>  handleNewsletterDlt(newsletter.No)}> <img src={close} alt="cross" style={{marginTop:'14px'}} /></button>
       
        </div>
  )
}

export default NewsletterDiv